// extracted by mini-css-extract-plugin
export var container = "_6i-0";
export var error = "_6i-9";
export var label = "_6i-5";
export var light = "_6i-6";
export var md = "_6i-3";
export var sm = "_6i-2";
export var thin = "_6i-8";
export var thinBold = "_6i-7";
export var vertical = "_6i-4";
export var xs = "_6i-1";